import React, { memo, useCallback, useEffect, useState } from 'react'
import ProductDetailsForm from './product-details/ProductDetailsForm'
import { useParams } from 'react-router-dom';
import solarProductService from '../../../httpService/SolarProductService';
import { useDispatch } from 'react-redux';
import { setupSolarProductDetails } from '../../../stores/slices/solar-product-details-slice';
import { toast } from 'react-toastify';
import CommonLoadingSpinnerForPage from '../../../common/components/loading-spinner/CommonLoadingSpinnerForPage';

type Props = {}

const EditProduct: React.FC<Props> = memo((props: Props) => {
    let { id } = useParams();

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const fetchProduct = useCallback(async () => {
        try {
            setLoading(true);

            const response = await solarProductService.getById(id);

            dispatch(setupSolarProductDetails(
                {
                    editingProductId: id,
                    currentStep: 0,
                    firstStep: {
                        productName: response.data.productName,
                        productCapacity: response.data.productCapacity,
                        price: response.data.price.toString(),
                        activeDuration: response.data.activeDuration?.toString(),
                        batteryType: response.data.batteryType,
                        packageDescription: response.data.packageDescription,
                        categoryIds : response.data.categories.map(item => item.id)
                    },
                    secondStep: {
                        inverterType: response.data.inverterType,
                        warranty: response.data.warranty,
                        batteryVoltage: response.data.batteryVoltage,
                        type: response.data.type,
                        quantityAvailableForSale: response.data.quantityAvailableForSale?.toString()
                    },
                    thirdStep: {
                        costForBungalow: response.data.installationCostForBungalow.toString(),
                        costPerFloor: response.data.installationCostForFloorForStoryBuilding.toString(),
                        existingImages: response.data.images.map((image) => {
                            return {
                                name: image.imageUrl.split('/').pop() as string,
                                url: image.imageUrl,
                            }
                        }),
                        images: response.data.images.map((image) => {
                            return {
                                name: image.imageUrl.split('/').pop() as string,
                                url: image.imageUrl,
                            }
                        })
                    }
                }
            ));

        } catch (error) {
            toast.error("An error occurred while fetching product details");
        } finally {
            setLoading(false);
        }
    }, [id, dispatch]);

    useEffect(() => {
        fetchProduct();
    }, [fetchProduct]);

    return (
        <CommonLoadingSpinnerForPage loading={loading}>
            <ProductDetailsForm/>
        </CommonLoadingSpinnerForPage>
    )
})

export default EditProduct